import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/deal-packets/templates/$templateId")({
  staticData: {
    breadcrumb: "Template",
  },
  component: TemplateLayout,
})

function TemplateLayout() {
  return <Outlet />
}
